/* Body scroll lock — iOS ignores overflow:hidden alone. Shared by cart, shop, about. */
window.Cana = window.Cana || {};
window.Cana.lockBodyScroll = function lockBodyScroll() {
  if (document.body.dataset.scrollLocked === 'true') return;
  const y = window.scrollY || window.pageYOffset || 0;
  document.body.dataset.scrollLocked = 'true';
  document.body.dataset.scrollY = String(y);
  document.body.style.position = 'fixed';
  document.body.style.top = `-${y}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.classList.add('overflow-hidden');
};

/* #newHeader is a fixed, full-viewport scroller. Opening a product scrolls the
   Home/Shop pill and Cart chip above that scroller. Closing the cart used to
   leave that offset in place, so both stayed clipped off the top of the screen. */
window.Cana.resetHeaderChrome = function resetHeaderChrome() {
  const header = document.querySelector('#newHeader');
  if (!header) return;
  const active = document.activeElement;
  if (
    active &&
    active !== document.body &&
    header.contains(active) &&
    typeof active.blur === 'function'
  ) {
    active.blur();
  }
  if (header.scrollTop !== 0) header.scrollTop = 0;

  /* Focus returning to the product button can scroll this overlay again
     after the cart finishes closing. Hold the top until that settles,
     and let go as soon as Shop opens. */
  if (header.getAttribute('data-visible') === 'true') return;
  if (header.dataset.chromePinned === 'true') return;
  header.dataset.chromePinned = 'true';
  const pin = () => {
    if (header.getAttribute('data-visible') === 'true') {
      header.removeEventListener('scroll', pin);
      delete header.dataset.chromePinned;
      return;
    }
    if (header.scrollTop !== 0) header.scrollTop = 0;
  };
  header.addEventListener('scroll', pin, { passive: true });
  setTimeout(() => {
    header.removeEventListener('scroll', pin);
    delete header.dataset.chromePinned;
  }, 600);
};

window.Cana.unlockBodyScroll = function unlockBodyScroll() {
  if (document.body.dataset.scrollLocked !== 'true') return;
  const y = parseInt(document.body.dataset.scrollY || '0', 10);
  document.body.dataset.scrollLocked = 'false';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.classList.remove('overflow-hidden');
  window.scrollTo(0, y);
  window.Cana.resetHeaderChrome();
  requestAnimationFrame(window.Cana.resetHeaderChrome);
};

/**
 * /cart/add.js does not include a reliable item_count. Gift card adds were
 * leaving checkout disabled until a quantity change, which does return one.
 * Ask the cart itself and match the button to that count.
 */
let drawerCheckoutSync = 0;
window.Cana.syncDrawerCheckout = function syncDrawerCheckout() {
  const token = ++drawerCheckoutSync;
  const root = (window.routes && window.routes.cart_url) || '/cart';
  fetch(`${root}.js`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      if (!response.ok) throw new Error('cart');
      return response.json();
    })
    .then((cart) => {
      if (token !== drawerCheckoutSync) return;
      const checkout = document.querySelector('#CartDrawer-Checkout');
      if (!checkout || typeof cart.item_count !== 'number') return;
      if (cart.item_count > 0) checkout.removeAttribute('disabled');
      else checkout.setAttribute('disabled', 'disabled');
    })
    .catch(() => {});
};

window.Cana.releaseDrawerCheckout = function releaseDrawerCheckout() {
  const checkout = document.querySelector('#CartDrawer-Checkout');
  if (checkout && document.querySelector('#CartDrawer [id^="CartDrawer-Item-"]')) {
    checkout.removeAttribute('disabled');
  }
  window.Cana.syncDrawerCheckout();
};

/** Paint only the green count chip — never replace #cart-icon-bubble wholesale. */
window.Cana.paintCartBubble = function paintCartBubble(sectionHtml, itemCount) {
  const bubble = document.querySelector('#cartQuantity');
  if (!bubble) return;

  if (typeof itemCount === 'number') {
    bubble.textContent = itemCount > 0 ? String(itemCount) : '';
    return;
  }

  if (!sectionHtml) return;
  const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const count = parsed.querySelector('.cart-count-bubble span[aria-hidden]');
  bubble.textContent = count ? count.textContent.trim() : '';
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this._onOverlayClick = this.close.bind(this);

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close(),
    );

    const overlay = document.querySelector('#newHeader #overlay');
    if (overlay) {
      overlay.addEventListener('click', this._onOverlayClick);
    }

    this.setHeaderCartIconAccessibility();

    window.CartDrawer = this;
    this.isOpen = false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    this.isOpen = true;
    const overlay = document.querySelector('#newHeader #overlay');
    if (overlay) overlay.setAttribute('data-visible', 'true');

    setTimeout(() => {
      this.classList.add('animate', 'active');
      /* iPhone: both panels fill the screen, so shop leaves as the cart
         arrives. iPad (768px) and up can show both. isOpen is already true,
         and keepLock stops shop close from unlocking the page for a frame. */
      if (
        window.matchMedia('(max-width: 767px)').matches &&
        window.ProductShowcaseWindow &&
        window.ProductShowcaseWindow.isOpen &&
        typeof window.ProductShowcaseWindow.close === 'function'
      ) {
        window.ProductShowcaseWindow.close({ keepLock: true });
      }
    });

    if (window.Cana && typeof window.Cana.lockBodyScroll === 'function') {
      window.Cana.lockBodyScroll();
    } else {
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
    this.classList.remove('active');
    this.isOpen = false;

    const shopOpen =
      window.ProductShowcaseWindow && window.ProductShowcaseWindow.isOpen;
    if (!shopOpen) {
      const overlay = document.querySelector('#newHeader #overlay');
      if (overlay) overlay.setAttribute('data-visible', 'false');
      if (window.Cana && typeof window.Cana.unlockBodyScroll === 'function') {
        window.Cana.unlockBodyScroll();
      } else {
        document.body.classList.remove('overflow-hidden');
      }
      /* After the drawer unhides, Safari may scroll the focused product
         control into view and clip the header again. Reset once the frame lands. */
      if (window.Cana && typeof window.Cana.resetHeaderChrome === 'function') {
        window.Cana.resetHeaderChrome();
        requestAnimationFrame(window.Cana.resetHeaderChrome);
      }
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.getAttribute('id'),
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'),
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('#DrawerInner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;

    const sections = parsedState.sections || {};

    if (sections['cart-drawer']) {
      const html = this.getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      const target = document.querySelector('#CartDrawer');
      if (html != null && target) target.innerHTML = html;
    }

    if (window.Cana && typeof window.Cana.paintCartBubble === 'function') {
      window.Cana.paintCartBubble(
        sections['cart-icon-bubble'],
        typeof parsedState.item_count === 'number' ? parsedState.item_count : undefined,
      );
    }

    const checkout = this.querySelector('#CartDrawer-Checkout');
    // An add response can omit item_count, or report 0 for a gift card while
    // the line is already in the cart. Never disable from that payload.
    if (
      checkout &&
      typeof parsedState.item_count === 'number' &&
      parsedState.item_count > 0
    ) {
      checkout.removeAttribute('disabled');
    }
    if (window.Cana && typeof window.Cana.releaseDrawerCheckout === 'function') {
      window.Cana.releaseDrawerCheckout();
    }

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    if (!html) return null;
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

window.CartDrawer = CartDrawer;
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cartQuantity',
        paintBubble: true,
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
